import { isEmpty } from "lodash";

const versionGuard = (meta) => meta.dispatch(versionGuardAction(meta));

const versionGuardAction = (to) => (_dispatch, getState) => {

	const { version } = getState();

	// redirect to update page if state is not ok
	if (!isEmpty(version.data) && (version.data.status === "UPDATE_AVAILABLE" || version.data.status !== "OK")) {
        return "/software-update";
    }

	return null;
}

export { versionGuard }
